import React from 'react';

export default function StatusMessage({ type = 'info', message, onClose }) {
  if (!message) return null;

  const style = {
    success: { background: '#d1e7dd', color: '#0a3622', border: '1px solid #a3cfbb' },
    error: { background: '#f8d7da', color: '#58151c', border: '1px solid #f1aeb5' },
    info: { background: '#cfe2ff', color: '#052c65', border: '1px solid #9ec5fe' },
    warning: { background: '#fff3cd', color: '#664d03', border: '1px solid #ffe69c' },
  }[type] || { background: '#cfe2ff', color: '#052c65', border: '1px solid #9ec5fe' };

  return (
    <div
      className="status-message"
      style={{
        ...style,
        padding: '0.6rem 1rem',
        borderRadius: '0.5rem',
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.5rem',
      }}
      role="alert"
    >
      <span>{message}</span>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '1.2rem',
            lineHeight: 1,
            padding: 0,
          }}
          aria-label="Close message"
        >
          &times;
        </button>
      )}
    </div>
  );
}